module.exports = "https://www.gc-pro.gnp.com.mx/79689a3149c7bf5e5cb239120ee63e5b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/warning-new-style.svg
// module id = 64
// module chunks = 0